import { render, staticRenderFns } from "./KurumInfo.vue?vue&type=template&id=18a7c65d"
import script from "./KurumInfo.vue?vue&type=script&lang=ts"
export * from "./KurumInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports